import React, { useState, useEffect } from 'react';

import notificationServices from '../../../../../services/academy/notificationServices';

import { Dots } from "react-activity";

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input';
import { FaBell } from 'react-icons/fa';

function PopupNewNotification(props) {
    const [tittle, setTittle] = useState("");
    const [content, setContent] = useState("");
    const [sms, setSms] = useState(true);
    const [email, setEmail] = useState(true);

    const [uploading, setUploading] = useState(false);

    useEffect(() => {
        defineInitialTittle();
    }, []);

    function defineInitialTittle() {
        let userType = localStorage.getItem("_userType"), infos;

        if (userType === "academia") {
            infos = localStorage.getItem("_academyInfos");
            infos = JSON.parse(infos);
            setTittle(`Notificação de ${infos.nome}`);
        } else if (userType === "professor") {
            infos = localStorage.getItem("_coachInfos");
            infos = JSON.parse(infos);
            setTittle(`Notificação de ${infos.nome} ${infos.sobrenome}`);
        }
    }

    async function createNotification() {
        if (tittle && content) {
            setUploading(true);
            const response = await notificationServices.postClassNotification(props.classId, tittle, content,sms, email);
            setUploading(false);
            if (response.status === 204) {
                setTimeout(() => {
                    props.setVisibility(false);
                    defineInitialTittle();
                    setContent("");
                }, 500);
            } else
                alert("Erro ao adicionar notificação, tente novamente!");
        } else
            alert("Preencha os dados obrigatórios*");
    };

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            icon={<FaBell />}
            tittle='Nova notificação'

        >
            <form action="" className='class-new-notification-form'>
                <Input
                    label='Título*'
                    placeholder="Insira aqui o título"
                    id='class-new-notification-tittle'
                    onChange={(event) => setTittle(event.target.value)}
                    value={tittle}
                />
                <Input
                    label='Conteúdo*'
                    placeholder="Insira aqui o conteúdo"
                    type='textarea'
                    rows={3}
                    id='class-new-notification-content'
                    onChange={(event) => setContent(event.target.value)}
                    value={content}
                />
                <Input
                    label='SMS'
                    placeholder="Enviar notificação por sms"
                    type='checkbox'
                    id='class-new-notification-sms'
                    onChange={(event) => setSms(!sms)}
                    value={sms}
                    checked={sms}
                />
                <Input
                    label='Email'
                    placeholder="Enviar notificação por email"
                    type='checkbox'
                    id='class-new-notification-email'
                    onChange={(event) => setEmail(!email)}
                    value={email}
                    checked={email}
                />
                <button
                    type='button'
                    onClick={() => uploading ? alert("Um envio já está em andamento.") : createNotification()}
                >
                    {
                        uploading ?
                            <Dots />
                            : "Enviar"
                    }
                </button>
            </form>
        </Popup>
    )
}

export default PopupNewNotification;